import React from "react"

type PanelProps = {
  disabled?: boolean
  full_height?: boolean
  overflowVisible?: boolean
  overflowAuto?: boolean
  classNames?: string
  overflow?: string
}

export class Panel extends React.Component<PanelProps> {
  render() {
    return (
      <div className={"border-t bg-gray-100 border-gray-200 shadow-md rounded-lg m-2 " + (this.props.disabled ? ' opacity-50 ' : '')
      + (this.props.full_height ? 'h-full' : '')
      + (this.props.overflowVisible ? ' overflow-visible' : '')
      + (this.props.overflow ? this.props.overflow : this.props.overflowAuto ? ' overflow-auto ' : ' overflow-hidden ')
      + (this.props.classNames ? ' ' + this.props.classNames + ' ' : '')}>
        {this.props.children}
      </div>
    )
  }
}
